import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eda75532"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.milva.dk/",
  target: "_blank"
}, "milva.dk", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(".")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSVG = _resolveComponent("InlineSVG")!
  const _component_PageGuideSlide = _resolveComponent("PageGuideSlide")!

  return (_openBlock(), _createBlock(_component_PageGuideSlide, { class: "Slide Outro" }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.mixWB('UNDER_CONSTANT_DEVELOPMENT')), 1)
    ]),
    intro: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(_ctx.mixWB('GUIDE_SLIDE_OUTRO_TEXT_1')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(_ctx.mixWB('GUIDE_SLIDE_OUTRO_TEXT_2')), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.mixWB('GUIDE_SLIDE_OUTRO_TEXT_3')), 1),
      _createVNode(_component_InlineSVG, {
        class: "MilvaIcon",
        src: require('@/assets/logo/milva-icon.svg')
      }, null, 8, ["src"]),
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(_ctx.mixWB('READ_MORE_ABOUT_MILVA_AT')) + " ", 1),
        _hoisted_1,
        _hoisted_2
      ])
    ]),
    _: 1
  }))
}